export const SIDEBAR_CONTENT = {
  CHATS: "chats",
  CONTACTS: "contacts",
}
